<template>
	<div v-if="Character.Equipment.Magic.length > 0">
		<h5 class="mt-2">Magic Items</h5>
		<b-table-simple responsive small bordered striped table-class="mb-0" class="mt-2">
			<b-thead>
				<b-tr>
					<b-th>Type</b-th>
					<b-th>Item</b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr v-for="(item, index) in Character.Equipment.Magic" :key="'equipment-magic-'+index">
					<b-td>{{item.Type}}</b-td>
					<b-td>{{item.Name}}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>